// extracted by mini-css-extract-plugin
export var container = "ComponentCard-module--container--03e12";
export var dataCategory = "ComponentCard-module--dataCategory--2f837";
export var dataLayer = "ComponentCard-module--dataLayer--4efee";
export var description = "ComponentCard-module--description--cde1b";
export var integrationCategory = "ComponentCard-module--integrationCategory--ce852";
export var integrationLayer = "ComponentCard-module--integrationLayer--4e95c";
export var interactionCategory = "ComponentCard-module--interactionCategory--93f71";
export var interactionLayer = "ComponentCard-module--interactionLayer--a676e";
export var interfaceCategory = "ComponentCard-module--interfaceCategory--89343";
export var interfaceLayer = "ComponentCard-module--interfaceLayer--77c11";
export var layerTags = "ComponentCard-module--layerTags--c2d5b";
export var procesCategory = "ComponentCard-module--procesCategory--af31e";
export var processCategory = "ComponentCard-module--processCategory--f9421";
export var processLayer = "ComponentCard-module--processLayer--b72d0";
export var processsLayer = "ComponentCard-module--processsLayer--d4e6b";
export var serviceCategory = "ComponentCard-module--serviceCategory--10760";
export var serviceLayer = "ComponentCard-module--serviceLayer--59536";
export var servicesCategory = "ComponentCard-module--servicesCategory--1a432";
export var servicesLayer = "ComponentCard-module--servicesLayer--3f8c1";
export var tags = "ComponentCard-module--tags--d6066";
export var title = "ComponentCard-module--title--0eed1";
export var unknownCategory = "ComponentCard-module--unknownCategory--d54dc";
export var unknownLayer = "ComponentCard-module--unknownLayer--4b9c9";